import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { ExpansionList, ExpansionPanel, DatePicker, SelectField } from "react-md";
import { cloneDeep } from "lodash";
import { Button } from "react-md/lib/Buttons";
import { dateToString } from "components/Shared/Formatters";

const primaryLabel = (designation) => {
  return ((designation.appraiserDesignationType ? designation.appraiserDesignationType.name : "") + " " + designation.status);
};

const blankDesignation = () => {
  return {
    id: 0,
    appraiserId: 0,
    appraiserDesignationTypeId: 0,
    designationCode: null,
    validFrom: null,
    validTo: null,
    status: "NEW",
    appraiserDesignationType: {
      id: 0,
      abbreviation: null,
      name: "New Item",
      code: null,
      description: null,
      requiresRenewal: true,
      renewalIntervalDays: 365
    }
  };
};

const secondaryLabel = (designation) => {
  return (designation.validFrom ? dateToString(designation.validFrom) + " - " : "") + (designation.validTo ? dateToString(designation.validTo) : "");
};

class RenderDesignations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      designation: []
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.setState({ designation: this.props.fields });
  }

  handleSave() {
    this.props.saveDesignation(this.state.designation);
  }

  handleRemove(index) {
    let newDesignation = cloneDeep(this.state.designation);
    newDesignation[index].status = "REMOVE";
    this.props.saveDesignation(newDesignation);
  }

  render() {
    const { designation } = this.state;
    return (
      <div className="md-grid">
        <ExpansionList className="md-cell md-cell--12 md-cell--right">
          {designation && designation.map((designation, index) => {
            let currentItem = designation;
            return (
              <ExpansionPanel className="md-cell md-cell--12 md-cell--right"
                key={index}
                label={`${primaryLabel(currentItem)}`}
                secondaryLabel={`${secondaryLabel(currentItem)}`}
                saveProps={{
                  flat: true,
                  disabled: this.state.designation[index].appraiserDesignationTypeId === 0
                }}
                cancelProps={{
                  flat: true
                }}
                onSave={this.handleSave}
                contentClassName="md-grid"
              >
                <SelectField
                  id="select-field-1"
                  label="Designation Type"
                  itemLabel="name"
                  itemValue="id"
                  menuItems={this.props.designationList.map(x => ({ name: x.name, id: x.id }))}
                  className="md-cell md-cell--12 md-cell--right"
                  onChange={(value) => {
                    let newDesignation = cloneDeep(this.state.designation);
                    newDesignation[index].appraiserDesignationTypeId = value;
                    this.setState({ designation: newDesignation });
                  }}
                  value={this.state.designation[index].appraiserDesignationTypeId}
                />
                <DatePicker
                  id="date-picker-1"
                  className="md-cell md-cell--6"
                  label="Valid From Date"
                  onChange={(date) => {
                    let newDesignation = cloneDeep(this.state.designation);
                    newDesignation[index].validFrom = date;
                    this.setState({ designation: newDesignation });
                  }}
                  value={this.state.designation[index].validFrom ? new Date(this.state.designation[index].validFrom).toLocaleDateString() : null}
                />
                <DatePicker
                  id="date-picker-2"
                  className="md-cell md-cell--6 md-cell--right"
                  label="Valid To Date"
                  onChange={(date) => {
                    let newDesignation = cloneDeep(this.state.designation);
                    newDesignation[index].validTo = date;
                    this.setState({ designation: newDesignation });
                  }}
                  value={this.state.designation[index].validTo ? new Date(this.state.designation[index].validTo).toLocaleDateString() : null}
                />
                <div className="md-cell md-cell--12 offset-md--4">
                  <i className="md-icon material-icons" onClick={() => this.handleRemove(index)} >delete</i>
                </div>
              </ExpansionPanel>);
          })}
        </ExpansionList>
        <Button className="md-cell md-cell--12 md-cell--right"
          flat
          secondary
          iconChildren="add"
          onClick={() => {
            let newDesignation = cloneDeep(this.state.designation);
            newDesignation.push(blankDesignation());
            this.setState({ designation: newDesignation });
          }}>Add Designation
        </Button>
      </div>
    );
  }
}

RenderDesignations.propTypes = {
  fields: PropTypes.array,
  designationList: PropTypes.array,
  saveDesignation: PropTypes.func
};

const mapStateToProps = state => {
  return {
    designationList: state.appraiser.designationList,
  };
};

export default connect(mapStateToProps)(RenderDesignations);